export default {
  release: '17.0',
  date: 'May 2024',
  releasePostUrl: 'https://docs.gitlab.com/releases/17/gitlab-17-0-released/#this-months-notable-contributor',
  contributors: [
    {
      name: 'Niklas van Schrick',
      gitlabUsername: 'Taucher2003',
    },
    {
      name: 'Gerardo Navarro',
      gitlabUsername: 'gerardo-navarro',
    },
  ],
  writeUp: `Niklas van Schrick now has the hat trick with three MVPs and has become one of GitLab's most consistent contributors with at least one merge request per milestone since GitLab 14.3.

Niklas was nominated by [Magdalena Frankiewicz](https://gitlab.com/m_frankiewicz), Product Manager at GitLab, for contributing a feature to create custom webhook payload templates and then following it up with the [ability to specify custom webhook headers](https://gitlab.com/gitlab-org/gitlab/-/issues/17290).
"This solved a highly demanded 7-year-old feature request with 65 upvotes," says Magdalena.
"Users can now fully design custom webhooks!"

Niklas is a member of the [GitLab Core Team](https://about.gitlab.com/community/core-team/) and helps the wider community and GitLab live up to our mission to enable everyone to contribute.

"During my journey, I interacted with a lot of different reviewers, maintainers, designers, technical writers, product managers, and probably more," Niklas says.
"Everyone was helpful and did their best to help move issues and merge requests forward."

Gerardo Navarro has been contributing to GitLab for over a year and takes home a second GitLab MVP award.

Gerardo was nominated for creating ongoing contributions towards a feature to [show protected packages in the package registry list](https://gitlab.com/gitlab-org/gitlab/-/issues/437926). This feature is part of a series of contributions related to the [protected packages epic](https://gitlab.com/groups/gitlab-org/-/epics/5574) that intends to increase security by enabling fine-grained permissions to create, update, and delete packages from the package registry.

Many thanks to Gerardo Navarro and the rest of the team from Siemens for helping co-create GitLab.

"Thank you very much for appreciating our work with such a cool award," says Gerardo.
"I feel honored. I am still learning a lot with every contribution."`,
};
